import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'

// Packages
import { reduxForm, Field, FieldArray } from 'redux-form'

// Helpers
import { required } from '../../../../../utils/formValidators'

// Form Components
import ReduxFormInput from '../../../../../components/Global/ReduxForms/ReduxFormInput'

class LockerAwardsForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    participation: PropTypes.object.isRequired
  }

  render() {
    return(
      <form onSubmit={this.props.handleSubmit}>
        <p className="medium-type-note">
          Award Description
        </p>
        <FieldArray
          name="awards"
          component={renderAwards}
        />
        <hr />
        <button className="cta-gradient" type="submit">
          Save Changes
        </button>
      </form>
    )
  }
}

const renderAwards = ({ fields }) => (
  <ul>
    {
      fields.map((award, index) => (
        <li key={index}>
          <Field
            name={award}
            type="text"
            component={ReduxFormInput}
            validate={required}
            placeholder="Enter an award description"
            handleInputRemoval={() => fields.remove(index)}
          />
        </li>
      ))
    }
    <li>
      <button type="button" className="cta invert" onClick={() => fields.push("")}>
        + Add an Award
      </button>
    </li>
  </ul>
)

// Connect to redux-form
LockerAwardsForm = reduxForm({
  form: 'LockerAwardsForm'
})(LockerAwardsForm)


// Connect to redux
const mapStateToProps = (state, ownProps) => {
  const { awards } = ownProps.participation

  return ({
    initialValues: {
      awards: awards.length > 0 ? awards : ['']
    }
  })
}

export default connect(mapStateToProps)(LockerAwardsForm)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Locker/LockerScreens/LockerAwardsForm/LockerAwardsForm.js